export default import.meta.ROLLDOWN_FILE_URL_lU$Cierj8Oal1NpnwtR8UQ